import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles//Interface/multiply-model.interface';
import { mergeNoConflictProperty } from '../utils/merge-property';
import { ILockProperty, ILocks, Locks, LOCK_KEY } from './lock.interface';
import { getNoChangeAspectType } from './data';
import { transaction } from '@src/slide/domain/slide-app';

export default class Lock implements ILockProperty {
    private model: IElementBaseModel | IMultiplyModel;

    /**
     * 多选图形、组合的属性是综合所有子元素而来的，基于性能考虑，加入缓存，只在必要时重新获取更新缓存
     * @private
     */
    private mergePropertyValCache: ILocks | undefined;

    public constructor(model: IElementBaseModel | IMultiplyModel) {
        this.model = model;
    }

    public getLockInfo(): ILocks | undefined {
        if (this.model.type === UIModelType.MULTIPLY) {
            return this.mergePropertyValCache;
        }
        return {
            noChangeAspectType: getNoChangeAspectType(this.model.props[Locks.LOCKS]),
        };
    }

    public updateLocks(value: number): void {
        transaction(() => {
            this.handleLocks(this.model, value);
        });
    }

    /**
     * 刷新 多选图形|组合 合并后的效果值
     */
    public refreshMergePropertyValCache(): ILocks | undefined {
        if (this.model.type === UIModelType.MULTIPLY) {
            const mergeModel = this.model as IMultiplyModel;
            const getPropertyFunc = (model: IElementBaseModel) => ({
                [LOCK_KEY]: model.getLock?.().getLockInfo(),
            });
            const uiModelPropertyObj = mergeNoConflictProperty(mergeModel, getPropertyFunc);
            this.mergePropertyValCache = uiModelPropertyObj[LOCK_KEY];
        }
        return this.mergePropertyValCache;
    }

    private handleLocks = (model: IElementBaseModel | IMultiplyModel, value: number) => {
        if (model.type === UIModelType.TABLE) {
            return;
        }
        if (model.type === UIModelType.MULTIPLY) {
            const { selectedModels } = model as IMultiplyModel;
            selectedModels.forEach((childModel: IElementBaseModel) => {
                this.handleLocks(childModel, value);
            });
        } else {
            model.updateProps({
                [Locks.LOCKS]: {
                    noChangeAspect: value,
                },
            });
        }
    };
}
